import { BaseApi } from "./base-api.service";

export class DropDownService extends BaseApi {
  constructor() {
    super();
    this.auth = true;
  }
  async ComicCategories(): Promise<string[]> {
    const url = `${this.apiUrl}/lists/document-categories`;
    const options = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    return this.get<string[]>(url, options);
  }
  async ComicLanguages(): Promise<string[]> {
    const url = `${this.apiUrl}/lists/languages`;
    const options = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    return this.get<string[]>(url, options);
  }

  async OfferorCategories(): Promise<string[]> {
    const url = `${this.apiUrl}/lists/offeror-categories`;
    const options = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    return this.get<string[]>(url, options);
  }
  async SystemParameters(): Promise<string[]> {
    const url = `${this.apiUrl}/lists/parameters`;
    const options = {
      headers: {
        "Content-Type": "application/json",
      }
    };
    return this.get<string[]>(url, options);
  }
}
